
:host {
    --wcs-galactic-background-color: var(--wcs-semantic-color-background-surface-inverse);
    --wcs-galactic-text-color: var(--wcs-semantic-color-text-inverse);
    --wcs-galactic-height: var(--wcs-semantic-size-s);
    --wcs-galactic-font-size: var(--wcs-semantic-font-size-label-2);
    --wcs-galactic-font-weight: var(--wcs-semantic-font-weight-medium);
    --wcs-galactic-max-width: var(--wcs-com-content-max-width);
    --wcs-galactic-padding-horizontal: calc(2 * var(--wcs-semantic-spacing-base));
    --wcs-galactic-logo-height: var(--wcs-semantic-size-s);
    --wcs-galactic-logo-margin-right: calc(2 * var(--wcs-semantic-spacing-base));

    /* To enforce contrast color on dropdown / buttons added in the galactic slot */
    --wcs-semantic-color-foreground-action-tertiary-default: var(--wcs-galactic-text-color);

    display: block;
    background-color: var(--wcs-galactic-background-color);
}

.container {
    height: var(--wcs-galactic-height);
    align-items: center;
    justify-content: space-between;
    color: var(--wcs-galactic-text-color);
    font-size: var(--wcs-galactic-font-size);
    font-weight: var(--wcs-galactic-font-weight);
    display: flex;
    max-width: var(--wcs-galactic-max-width);
    padding: 0 var(--wcs-galactic-padding-horizontal);
    margin: 0 auto;

    #sncf-logo {
        height: var(--wcs-galactic-logo-height);
        margin-right: var(--wcs-galactic-logo-margin-right);
    }

    .logo-container {
        display: flex;
        align-items: center;
    }
}

.actions-container {
    display: flex;
    align-items: center;
}
